import React, { useState, useEffect } from "react";
import { Card, Grid2, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import MUILoader from "../../../components/MUILoader/MUILoader";
import MUITableSearch from "../../../components/MUITable/MUITableSearch";
import { handleOutSideDataTableSearch } from "../../../common/MuiTableFunctions.config";
import AssignSuperAdminDataTable from "./components/AssignSuperAdminDataTable";
import { AssignSuperAdminDataTableColumns } from "./components/AssignSuperAdminDataTable.config";
import { useSnackbar } from "../../../contexts/Snackbar.context";
import {
  APP_MESSAGE,
  SNACKBAR_VARIANT,
  ERROR_MESSAGE,
} from "../../../config/Messages.config";
import {
  assignNewSuperAdminToExistingAccount,
  getAllCompaniesInfo,
  getAssignedSuperAdminForCompany,
} from "../../../helpers/api-functions-helper";
import currentlyAssignedImg from "../../../assets/images/CurrentlyAssigned.svg"
import AssignSuperAdminWarningModal from "./components/AssignSuperadminWarningModal";

const AssignSuperAdminMaster = () => {
  const { showSnackbar } = useSnackbar();
  const documentTitle = "Assign Zingworks Super Admin";
  document.title = documentTitle ? `${documentTitle} | Zing Auditor` : "Zing Auditor"
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [tableDataInstance, setTableDataInstance] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [
    accountDetailsOfAssignedSuperAdmin,
    setAccountDetailsOfAssignedSuperAdmin,
  ] = useState({
    accountId: null,
    details: null,
  });

  // Waring modal to assign or remove assignee from account
  const [isAddOrRemoveAssigneeClicked, setIsAddOrRemoveAssigneeClicked] =
    useState(false);
  const [addOrRemoveAssigneeModal, setAddOrRemoveAssigneeModal] = useState({
    isOpen: false,
    type: "",
    accountId: null
  })

  const toggleAddOrRemoveAssigneeModal = (ModalState, Type, AccountId) => {
    setAddOrRemoveAssigneeModal((prev) => ({
      ...prev,
      isOpen: ModalState,
      type: Type,
      accountId: AccountId
    }))
  }


  // search functionality
  const [searchText, setSearchText] = useState("");

  // Fetch all plants
  const fetchAllCompaniesInfo = () => {
    setIsPageLoading(true);
    getAllCompaniesInfo()
      .then((response) => {
        if (response && response.data) {
          const { success, statusCode, data, message } = response.data;
          if (success && statusCode === 200) {
            setTableDataInstance(data);
            setTableData(data);
          } else {
            showSnackbar(
              message || data || APP_MESSAGE.ASSIGN_SUPER_ADMIN_MASTER.FETCHED.FAILED,
              SNACKBAR_VARIANT.ERROR
            );
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.ASSIGN_SUPER_ADMIN_MASTER.FETCHED.FAILED,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setIsPageLoading(false);
      });
  };

  // Fetch the account-id to which zingworks has assigned a super-admin
  const fetchAccountIdOfAssignedSuperAdmin = () => {
    setIsPageLoading(true)
    getAssignedSuperAdminForCompany()
    .then((response) => {
      if (response && response.data) {
        const { success, statusCode, data, message } = response.data;
        if (success && statusCode === 200) {
          if (data) {
            setAccountDetailsOfAssignedSuperAdmin((prev) => ({
              ...prev,
              accountId: data?.accountId || ""
            }))
          }
          fetchAllCompaniesInfo()
        } else {
          showSnackbar(
            message ||
              data ||
              APP_MESSAGE.ASSIGN_SUPER_ADMIN_MASTER
                .ASSIGNED_SUPER_ADMIN_ACCOUNT_ID.FAILED,
            SNACKBAR_VARIANT.ERROR
          );
          setIsPageLoading(false);
        }
      }
    })
    .catch((error) => {
      console.log("Error: ", error);
      showSnackbar(
        APP_MESSAGE.ASSIGN_SUPER_ADMIN_MASTER.ASSIGNED_SUPER_ADMIN_ACCOUNT_ID
          .FAILED,
        SNACKBAR_VARIANT.ERROR
      );
      setIsPageLoading(false);
    })
  }

  // Function to re-assign super-admin to another account/company
  const reAssignNewSuperAdminToExistingAccount = (ID) => {
    setIsAddOrRemoveAssigneeClicked(true);
    const payload = { accountId: ID };
    assignNewSuperAdminToExistingAccount(payload)
      .then((response) => {
        if (response && response.data) {
          const { success, statusCode, data, message } = response.data;
          if (success && statusCode === 200) {
            // console.log("Re-assign: ", data)
            showSnackbar(
              message ||
                data ||
                (ID !== ""
                  ? APP_MESSAGE.ASSIGN_SUPER_ADMIN_MASTER.ASSIGN.SUCCESS
                  : APP_MESSAGE.ASSIGN_SUPER_ADMIN_MASTER.UN_ASSIGN.SUCCESS),
              SNACKBAR_VARIANT.SUCCESS
            );
            toggleAddOrRemoveAssigneeModal(false, "", null)
            fetchAccountIdOfAssignedSuperAdmin();
          } else {
            showSnackbar(
              message ||
                data ||
                (ID !== ""
                  ? APP_MESSAGE.ASSIGN_SUPER_ADMIN_MASTER.ASSIGN.FAILED
                  : APP_MESSAGE.ASSIGN_SUPER_ADMIN_MASTER.UN_ASSIGN.FAILED),
              SNACKBAR_VARIANT.ERROR
            );
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.APP_MESSAGE.ASSIGN_SUPER_ADMIN_MASTER.ASSIGN.FAILED,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setIsAddOrRemoveAssigneeClicked(false);
      });
  };

  const fetchAccountDetails = () => {
    const { accountId } = accountDetailsOfAssignedSuperAdmin;
    const accountDetails = accountId
      ? [...tableData].filter((account) => account.id === accountId)
      : [];
    setAccountDetailsOfAssignedSuperAdmin((prev) => ({
      ...prev,
      details: accountDetails[0] ? accountDetails[0] : null,
    }));
  };

  // Effect to fetch company details to which super admin has assigned
  useEffect(() => {
    if (tableData && tableData[0]) {
      fetchAccountDetails()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData])

  // To fetch the data of Account Master
  useEffect(() => {
    if (navigator.onLine) {
      fetchAccountIdOfAssignedSuperAdmin();
    } else {
      showSnackbar(ERROR_MESSAGE.INTERNET_ERROR, SNACKBAR_VARIANT.ERROR);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Outside Table search functionality
  useEffect(() => {
    if (searchText === "") {
      // Reset to original data if search text is cleared
      setTableData(tableDataInstance);
    } else {
      const filteredData_ = handleOutSideDataTableSearch(
        searchText,
        tableDataInstance
      );
      setTableData(filteredData_);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  return (
    <React.Fragment>
      {addOrRemoveAssigneeModal.isOpen && (
        <AssignSuperAdminWarningModal
          LoaderState={isAddOrRemoveAssigneeClicked}
          Data={{ ...addOrRemoveAssigneeModal }}
          OnSubmit={(ID) => reAssignNewSuperAdminToExistingAccount(ID)}
          ToggleFunction={(isOpen, type, id) =>
            toggleAddOrRemoveAssigneeModal(isOpen, type, id)
          }
        />
      )}
      <div className="page-content">
        {isPageLoading ? (
          <MUILoader />
        ) : (
          <div>
            <Grid2
              container
              className="d-flex align-items-center my-1"
              spacing={2}
            >
              <Grid2 size={{xs: 12, sm: 7, md: 8, lg: 8}} className="py-1">
                <Typography className="inter-medium-500">
                  {documentTitle}
                </Typography>
              </Grid2>

              {tableDataInstance[0] && (
                <Grid2 size={{xs: 12, sm: 5, md: 4, lg: 4}} className="py-1">
                  <Card>
                    <div className="d-flex align-items-center p-2 gap-2">
                      <img
                        src={currentlyAssignedImg}
                        alt={"Assigned Icon"}
                        style={{ height: "40px", width: "40px" }}
                      />
                      <div className="d-grid align-items-center">
                        <Typography
                          className="inter-regular-400"
                          style={{ fontSize: "13px" }}
                        >
                          Currently Assigned To:
                        </Typography>
                        <Typography
                          noWrap
                          style={{ fontSize: "13px" }}
                          className="inter-regular-400"
                        >
                          {accountDetailsOfAssignedSuperAdmin?.details
                            ? accountDetailsOfAssignedSuperAdmin?.details?.name
                            : "Not Assigned"}
                        </Typography>
                      </div>
                    </div>
                  </Card>
                </Grid2>
              )}
            </Grid2>

            <Divider
              style={{ color: "GrayText", border: "0.02rem solid GrayText" }}
              className="mt-2"
            />

            <Grid2 container className="my-2" spacing={2}>
              <Grid2 size={{xs: 12, sm: 4, md: 4, lg: 4}}>
                <MUITableSearch
                  CancelSearch={() => {
                    setSearchText("");
                  }}
                  HandleSearch={(e) => setSearchText(e.target.value)}
                  SearchText={searchText}
                />
              </Grid2>
            </Grid2>

            <Grid2 container className="my-2">
              <Grid2 size={12}>
                <AssignSuperAdminDataTable
                  Columns={AssignSuperAdminDataTableColumns}
                  RowData={tableData || []}
                  DenseTable={true}
                  IsOutSideSearch={true}
                  RowsToDisplay={10}
                  ToggleWarningModal={(ModalState, Type, ID) => {
                    toggleAddOrRemoveAssigneeModal(ModalState, Type, ID)
                  }}
                  AccountId={accountDetailsOfAssignedSuperAdmin?.accountId}
                  OptionsForRowsPerPage={[5, 10, 15, 25, 50]}
                />
              </Grid2>
            </Grid2>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default AssignSuperAdminMaster;